module.exports = __webpack_public_path__ + "img/home-active.a8dab9e6.svg";